import { render, staticRenderFns } from "./ModalRefaz.vue?vue&type=template&id=5aa7b796&scoped=true"
import script from "./ModalRefaz.vue?vue&type=script&lang=js"
export * from "./ModalRefaz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa7b796",
  null
  
)

export default component.exports